export default __webpack_public_path__ + "static/media/pepe-lay.29b4285c.png";